<template>
	<div>
		<vx-card class="pr-4 pl-4 mb-5" no-shadow card-border :title="$t('MapModule.ScheduledRoute')">
			<div class="vx-row mb-6">
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label"> {{ $t("MapModule.StrokeWeight") }}</small>
					<vs-input-number class="w-full" :min="1" :max="10" v-model="optionsProgramedRouteLineWidth" />
				</div>
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label">{{ $t("MapModule.StrokeOpacity") }}</small>
					<vs-input-number
						class="w-full"
						:step="1"
						:min="1"
						:max="10"
						v-model="optionsProgramedRouteStrokeOpacity"
					/>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label"> {{ $t("MapModule.OptimizeWaypoints") }}</small>
					<vs-switch color="success" v-model="optionsProgramedRouteOptimizeWaypoints" />
				</div>
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label"> {{ $t("MapModule.StrokeColor") }}</small>
					<input class="w-full" type="color" v-model="optionsProgramedRouteStrokeColors" name="" value="" />
				</div>
			</div>
		</vx-card>

		<vx-card class="pr-4 pl-4 mt-5" no-shadow card-border :title="$t('MapModule.ExecutedRoute')">
			<div class="vx-row mb-6">
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label"> {{ $t("MapModule.StrokeWeight") }}</small>
					<vs-input-number class="w-full" :min="1" :max="10" v-model="optionsExecutedRouteLineWidth" />
				</div>
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label">{{ $t("MapModule.StrokeOpacity") }}</small>
					<vs-input-number
						class="w-full"
						:step="1"
						:min="1"
						:max="10"
						v-model="optionsExecutedRouteStrokeOpacity"
					/>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<small class="date-label"> {{ $t("MapModule.StrokeColor") }}</small>
					<input class="w-full" type="color" v-model="optionsExecutedRouteStrokeColors" name="" value="" />
				</div>
			</div>
		</vx-card>
		<vx-card class="pr-4 pl-4 mt-5" no-shadow card-border :title="$t('MapModule.ExecutedRouteLinear')">
			<vs-alert class="text-white" color="red" close-icon="close" :title="null" :active.sync="activeAlert">
				{{ $t("MapModule.AlertRouteLinear") }}
			</vs-alert>
			<div class="vx-row mb-6">
				<div class="vx-col w-full md:w-1/3" :title="$t('MapModule.ShowLinearRouteText')">
					<small class="date-label"> {{ $t("MapModule.Line") }}</small>
					<vs-switch color="success" v-model="enableLineWaypoints" :disabled="qtyResource > 1" />
				</div>
				<div class="vx-col w-full md:w-1/3" :title="$t('MapModule.ShowWaypointsText')">
					<small class="date-label"> {{ $t("MapModule.Points") }}</small>
					<vs-switch
						color="success"
						v-model="optionsExecuteRouteShowWaypoints"
						:disabled="qtyResource > 1"
						@input="openConfirm"
					/>
				</div>

				<div class="vx-col w-full md:w-1/3" :title="$t('MapModule.ShowLabelText')">
					<small class="date-label"> {{ $t("MapModule.Numbers") }}</small>
					<vs-switch
						color="success"
						v-model="enableWaypointsLabel"
						:disabled="!optionsExecuteRouteShowWaypoints || qtyResource > 1"
					/>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label"> {{ $t("MapModule.StrokeWeight") }}</small>
					<vs-input-number
						:disabled="!enableLineWaypoints || qtyResource > 1"
						class="w-full"
						:min="1"
						:max="10"
						v-model="optionsExecutedRouteStrokeWeightyTwo"
					/>
				</div>
				<div class="vx-col w-full md:w-1/2">
					<small class="date-label">{{ $t("MapModule.StrokeOpacity") }}</small>
					<vs-input-number
						:disabled="!enableLineWaypoints || qtyResource > 1"
						class="w-full"
						:step="1"
						:min="1"
						:max="10"
						v-model="optionsExecutedRouteStrokeOpacityTwo"
					/>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<small class="date-label"> {{ $t("MapModule.StrokeColor") }}</small>
					<input
						class="w-full"
						type="color"
						v-model="optionsExecutedRouteStrokeColorsTwo"
						name=""
						value=""
						:disabled="qtyResource > 1"
					/>
				</div>
			</div>
		</vx-card>
	</div>
</template>
<script>
import {changeRouteProperties, hideMarkers} from "../../utils/HereMap";

export default {
	props: {
		qtyResource: {
			type: Number,
			require: false,
			default: 0,
		},
	},
	data() {
		return {
			optionsProgramedRoute: {
				strokeColor: "#ff8c34",
				strokeOpacity: 0.5,
				lineWidth: 10,
				optimizeWaypoints: true,
				id: "RP",
			},
			optionsExecutedRoute: {
				strokeColor: "#0B8FF4",
				strokeOpacity: 0.8,
				lineWidth: 10,
				optimizeWaypoints: false,
				showWaypoints: false,
				waypointsLabel: false,
				waypointsColor: "#ff0000",
				lineWaypoints: false,
				lineWaypointsStrokeColor: "#ff0000",
				lineWaypointsStrokeOpacity: 0.8,
				lineWaypointsStrokeWeight: 3,
				id: "RE",
			},
			activeAlert: this.qtyResource > 1 ? true : false,
		};
	},
	computed: {
		optionsProgramedRouteLineWidth: {
			get() {
				return this.optionsProgramedRoute.lineWidth;
			},
			set(val) {
				this.optionsProgramedRoute.lineWidth = val;
			},
		},
		optionsProgramedRouteStrokeOpacity: {
			get() {
				return this.optionsProgramedRoute.strokeOpacity * 10;
			},
			set(val) {
				this.optionsProgramedRoute.strokeOpacity = val / 10;
			},
		},
		optionsProgramedRouteOptimizeWaypoints: {
			get() {
				return this.optionsProgramedRoute.optimizeWaypoints;
			},
			set(val) {
				this.optionsProgramedRoute.optimizeWaypoints = val;
			},
		},
		optionsProgramedRouteStrokeColors: {
			get() {
				return this.optionsProgramedRoute.strokeColor;
			},
			set(val) {
				this.optionsProgramedRoute.strokeColor = val;
			},
		},

		optionsExecutedRouteLineWidth: {
			get() {
				return this.optionsExecutedRoute.lineWidth;
			},
			set(val) {
				this.optionsExecutedRoute.lineWidth = val;
			},
		},
		optionsExecutedRouteStrokeOpacity: {
			get() {
				return this.optionsExecutedRoute.strokeOpacity * 10;
			},
			set(val) {
				this.optionsExecutedRoute.strokeOpacity = val / 10;
			},
		},
		optionsExecutedRouteOptimizeWaypoints: {
			get() {
				return this.optionsExecutedRoute.optimizeWaypoints;
			},
			set(val) {
				this.optionsExecutedRoute.optimizeWaypoints = val;
			},
		},
		optionsExecutedRouteStrokeColors: {
			get() {
				return this.optionsExecutedRoute.strokeColor;
			},
			set(val) {
				this.optionsExecutedRoute.strokeColor = val;
			},
		},
		enableLineWaypoints: {
			get() {
				return this.optionsExecutedRoute.lineWaypoints;
			},
			set(val) {
				this.optionsExecutedRoute.lineWaypoints = val;
			},
		},
		enableWaypointsLabel: {
			get() {
				return this.optionsExecutedRoute.waypointsLabel;
			},
			set(val) {
				this.optionsExecutedRoute.waypointsLabel = val;
			},
		},
		optionsExecutedRouteStrokeWeightyTwo: {
			get() {
				return this.optionsExecutedRoute.lineWaypointsStrokeWeight;
			},
			set(val) {
				this.optionsExecutedRoute.lineWaypointsStrokeWeight = +val;
			},
		},
		optionsExecutedRouteStrokeOpacityTwo: {
			get() {
				return this.optionsExecutedRoute.lineWaypointsStrokeOpacity * 10;
			},
			set(val) {
				this.optionsExecutedRoute.lineWaypointsStrokeOpacity = val / 10;
			},
		},
		optionsExecutedRouteStrokeColorsTwo: {
			get() {
				return this.optionsExecutedRoute.waypointsColor;
			},
			set(val) {
				this.optionsExecutedRoute.lineWaypointsStrokeColor = val;
				this.optionsExecutedRoute.waypointsColor = val;
			},
		},
		optionsExecuteRouteShowWaypoints: {
			get() {
				return this.optionsExecutedRoute.showWaypoints;
			},
			set(val) {
				this.optionsExecutedRoute.showWaypoints = val;
			},
		},
	},
	watch: {
		"optionsProgramedRoute.strokeOpacity"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_PROGRAMED_ROUTE", this.optionsProgramedRoute);
			changeRouteProperties(this.optionsProgramedRoute);
		},
		"optionsProgramedRoute.lineWidth"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_PROGRAMED_ROUTE", this.optionsProgramedRoute);
			changeRouteProperties(this.optionsProgramedRoute);
		},
		"optionsProgramedRoute.strokeColor"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_PROGRAMED_ROUTE", this.optionsProgramedRoute);
			changeRouteProperties(this.optionsProgramedRoute);
		},
		"optionsExecutedRoute.strokeOpacity"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.lineWidth"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.strokeColor"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
		},
		"optionsProgramedRoute.optimizeWaypoints"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_PROGRAMED_ROUTE", this.optionsProgramedRoute);
		},
		"optionsExecutedRoute.showWaypoints"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			if (!val) hideMarkers();
		},
		"optionsExecutedRoute.waypointsColor"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.lineWaypoints"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			this.$emit("togglePolylineEmit", val);
		},
		"optionsExecutedRoute.lineWaypointsStrokeColor"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			this.$emit("changePropertiesAuxiliaryRouteEmit", this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.lineWaypointsStrokeOpacity"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
			this.$emit("changePropertiesAuxiliaryRouteEmit", this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.lineWaypointsStrokeWeight"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
			this.$emit("changePropertiesAuxiliaryRouteEmit", this.optionsExecutedRoute);
		},
		"optionsExecutedRoute.waypointsLabel"(val) {
			this.$store.commit("moduleMap/SAVE_OPTIONS_EXECUTED_ROUTE", this.optionsExecutedRoute);
			changeRouteProperties(this.optionsExecutedRoute);
			this.$emit("enableMarkerLabelsForExecutedRouteEmit", {showLabel: val, opt: this.optionsExecutedRoute});
		},
	},
	mounted() {
		this.optionsProgramedRoute = {
			...this.$store.state.moduleMap.optionsProgramedRoute,
		};
		this.optionsExecutedRoute = {
			...this.$store.state.moduleMap.optionsExecutedRoute,
		};
	},
	beforeDestroy() {
		this.$store.dispatch("moduleMap/updateConfigurationOnIndexedDB");
	},
	methods: {
		openConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("MapModule.ShowWaypointsTextConfirm1")} ${this.$t(
						"MapModule.ShowWaypoints"
					)} ${this.$t("And")} ${this.$t("MapModule.ShowLabel")}, ${this.$t(
						"MapModule.ShowWaypointsTextConfirm2"
					)} ${this.$t("TextAccepContinue")}`,
					accept: () => {
						this.$emit("showMarkersForExecutedRouteEmit");
					},
					cancel: () => {
						this.optionsExecuteRouteShowWaypoints = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			}
		},
	},
};
</script>
